import RouteTemplate from 'ember-route-template';

import { service } from '@ember/service';
import Component from '@glimmer/component';
import linkToState from 'ember-route-state/helpers/link-to-state.js';
import { pageTitle } from 'ember-page-title';

import NextStep from 'rise-ui/components/time-series/next-step.gjs';
import SelectionActions from 'rise-ui/components/time-series/selection/actions.gjs';
import SelectionInstructions from 'rise-ui/components/time-series/selection/instructions.gjs';
import SelectionLocations from 'rise-ui/components/time-series/selection/locations.gjs';
import MaxLocations from 'rise-ui/components/time-series/selection/max-locations.gjs';
import not from 'rise-ui/helpers/not.js';
import string from 'rise-ui/helpers/string.js';
import { readOnly } from 'rise-ui/utils/object/computed.js';

export default RouteTemplate(class TimeSeriesSelectionTemplate extends Component {
  @service('time-series/dates') timeSeriesDates;
  @service('time-series/outputs') timeSeriesOutputs;
  @service('time-series/params') timeSeriesParams;
  @service timeSeriesQueries;

  @readOnly('timeSeriesParams.hasItem') hasItem;
  @readOnly('timeSeriesOutputs.hasItem') isValidItem;
  @readOnly('timeSeriesParams.hasModelRun') hasModelRun;
  @readOnly('timeSeriesOutputs.hasModelRun') isValidModelRun;

  @readOnly('timeSeriesDates.defaultDates') defaultDates;
  @readOnly('timeSeriesDates.itemDates') itemDates;
  @readOnly('timeSeriesDates.modelRunDates') modelRunDates;

  @readOnly('timeSeriesRoute.isClean') isClean;

  <template>
    {{pageTitle "Select Parameters and Date Ranges to Query Time Series Data"}}

    <div class="c-time-series-selection c-section">
      <SelectionInstructions />
      <MaxLocations />
      <SelectionActions />
      <SelectionLocations
        @hasItem={{this.hasItem}}
        @isValidItem={{this.isValidItem}}
        @itemDates={{this.itemDates}}
        @hasModelRun={{this.hasModelRun}}
        @isValidModelRun={{this.isValidModelRun}}
        @modelRunDates={{this.modelRunDates}}
      />
      <div class="c-section c-actions">
        <NextStep
          @disabled={{not this.timeSeriesOutputs.count}}
          @linkTo={{linkToState "time-series.output"}}
          @title="Continue to {{string "time-series-output-route"}}"
        >
          Next Step: {{string "time-series-output-route"}}
        </NextStep>
      </div>
    </div>
  </template>
});
